import clsx from "clsx";
import React, { DetailedHTMLProps, FC, HTMLAttributes, PropsWithChildren } from "react";

export interface PaginationNumbersItemProps
  extends Pick<DetailedHTMLProps<HTMLAttributes<HTMLLIElement>, HTMLLIElement>, "onClick"> {
  isActive: boolean;
  href?: string;
}

export const PaginationNumbersItem: FC<PropsWithChildren<PaginationNumbersItemProps>> = ({
  children,
  isActive,
  href,
  onClick,
}) => {
  const innerChild = (
    <li
      className={clsx(
        "flex items-center justify-center rounded-full p-3 leading-tight w-9 h-9 cursor-pointer",
        isActive
          ? "bg-primary text-light"
          : "text-dark hover:bg-primary-light border hover:border-neutral-dark"
      )}
      onClick={onClick}
    >
      {children}
    </li>
  );
  return href ? <a href={href}>{innerChild}</a> : innerChild;
};
